import { ChangeEvent, FC, useCallback } from 'react';

import Column from 'bloko/blocks/column';
import FormSpacer from 'bloko/blocks/form/FormSpacer';
import Select, { Option } from 'bloko/blocks/select';

import useTrls from 'hooks/translation/useTrls';

import { ActAdvertisingServiceType, setAdvertisingServiceType } from 'store/models/acts';
import { useDispatch, useSelector } from 'store/utils';

const SelectAdvertisingServiceType: FC = () => {
    const advertisingServiceType = useSelector((state) => state.acts.advertisingServiceType);

    const dispatch = useDispatch();

    const trl = useTrls();

    const ITEMS = {
        [ActAdvertisingServiceType.All]: trl('admin.actsReport.advertisingServiceType.all'),
        [ActAdvertisingServiceType.Information]: trl('admin.actsReport.advertisingServiceType.information'),
        [ActAdvertisingServiceType.Advertising]: trl('admin.actsReport.advertisingServiceType.advertising'),
        [ActAdvertisingServiceType.NotMarked]: trl('admin.actsReport.advertisingServiceType.notMarked'),
    };

    const onChange = useCallback(
        (event: ChangeEvent<HTMLSelectElement>) => {
            const value = event.target.value as ActAdvertisingServiceType;
            dispatch(setAdvertisingServiceType(value));
        },
        [dispatch]
    );

    return (
        <FormSpacer>
            <Column xs="2" s="2" m="2" l="2" container>
                <Select value={advertisingServiceType} onChange={onChange}>
                    {Object.entries(ITEMS).map(([key, value]) => (
                        <Option key={key} value={key}>
                            {value}
                        </Option>
                    ))}
                </Select>
            </Column>
        </FormSpacer>
    );
};

export default SelectAdvertisingServiceType;
